import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * Анимация только при переходе в active или явном клике по иконке.
 */
export function useMenuIconAnimation(isActive, durationMs) {
  const [playing, setPlaying] = useState(false);
  const wasActiveRef = useRef(isActive);

  const startAnimation = useCallback(() => {
    setPlaying(false);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => setPlaying(true));
    });
  }, []);

  useEffect(() => {
    if (isActive && !wasActiveRef.current) {
      startAnimation();
    }
    wasActiveRef.current = isActive;
  }, [isActive, startAnimation]);

  useEffect(() => {
    if (!playing) return undefined;
    const timer = setTimeout(() => setPlaying(false), durationMs);
    return () => clearTimeout(timer);
  }, [playing, durationMs]);

  const handleClick = useCallback(() => {
    startAnimation();
  }, [startAnimation]);

  return { playing, handleClick };
}
